import React, { createContext, useContext, useEffect, useState } from 'react';

interface UserContextValue {
  email: string | null;
  loading: boolean;
}

const UserContext = createContext<UserContextValue>({ email: null, loading: true });

export function useUser(): UserContextValue {
  return useContext(UserContext);
}

export const UserProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [email, setEmail] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const API_BASE_URL = process.env.REACT_APP_API_URL || '';
    fetch(`${API_BASE_URL}/api/me`, { credentials: 'include' })
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => {
        if (data?.email) setEmail(data.email);
      })
      .catch(() => {
        // Silently fail — user will appear as unknown
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <UserContext.Provider value={{ email, loading }}>
      {children}
    </UserContext.Provider>
  );
};
